export const OneDriveConsts = {
    SCOPE: 'openid profile offline_access Files.Read.All',
    CLIENT_ID:  process.env.ONEDRIVE_CLIENT_ID,
    REDIRECT_URI: process.env.ONEDRIVE_REDIRECT_URI,
    PERSONAL_DOMAIN: 'https://onedrive.live.com',
    SCRIPT_URL: 'https://js.live.net/v7.2/OneDrive.js',
    HOST_DOMAIN: process.env.PUBLIC_URL
}